import { sendItemUploadFeedbackArgsToParams } from 'data/api/transformers/arguments/send-item-upload-feedback-args-to-params'
import { SendItemUploadFeedbackArgs } from 'types/api/arguments/send-item-upload-feedback-args'
import { SendItemUploadFeedbackResp } from 'types/api/response/send-item-upload-feedback-resp'

import { api } from './api'

export const sendItemUploadFeedback = (args: SendItemUploadFeedbackArgs) =>
  api.put<SendItemUploadFeedbackResp>(
    '/items/upload_feedback',
    sendItemUploadFeedbackArgsToParams(args),
  )
